<template>
  <v-flex xs12 sm6 lg4 xl3>
    <v-card class="ma-3">
      <v-card-title primary-title>
        <h5 class="headline">{{ title }}</h5>
      </v-card-title>
      <v-card-text>
        <h2 class="display-3 text-xs-center">{{ value }}</h2>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'indicator',
  props: {
    title: String,
    value: [String, Number]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/Indicator.vue